import { css, type Theme } from "@emotion/react";

import { dimensions } from "@styles";

export const container = css`
  margin: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: none;
`;

export const header = (theme: Theme) => css`
  border-bottom: 1px solid ${theme.system.borderBase};
  display: flex;
  padding: 1.5rem;
  margin: 0 1.5rem;
  gap: 3.5rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    padding: 1.5rem 0 1rem;
    margin: 0;
    gap: 1.25rem;
  }
`;

export const logo = css`
  width: 9.5rem;
  height: 2.15rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    max-width: 5rem;
    max-height: 1.25rem;
  }
`;

export const content = css`
  width: 100%;
  flex: 1;
  max-width: 30.25rem;
  margin: auto;
  padding-block: 2rem;

  @media (min-width: ${dimensions.tablet}) {
    padding-block: 4rem;
  }
`;

export const wideContent = css`
  max-width: 40rem;
`;
